module.exports = __webpack_public_path__ + "static/img/ZiJinTongJiJiaShiCang.d8f68adb.jpg";